import React from 'react';

// Single centred statement framing why PE differs from VC — sets up Combined Services below.
const PEThesisStatement = () => (
    <section className="lp-pe-thesis">
        <div className="lp-pe-wrap">
            <p data-lp-reveal>VCs get flooded with inbound and have to sift through it. <b>PE houses work the other way round</b> — they set a thesis, then go hunting for the best-fit opportunities. Fewer deals, bigger cheques, and budget that finally makes external diligence worthwhile.</p>
        </div>
    </section>
);

export default PEThesisStatement;
